import { NavItems, ParentNavItem } from '@shared/Frontend/components/navItems'
import { Maybe } from 'ballerina-core'
import i18next from 'i18next'
import { NavigationResponse, parseParentNavigationItem } from './navigation.parser'

export const getNavigation = async (slug: string): Promise<Maybe<NavItems>> => {
  const response = await fetch(`/api/navigation?slug=${slug}&locale=${i18next.language}`)
  try {
    const json: NavigationResponse = await response.json()
    return json.items.map((item): ParentNavItem => parseParentNavigationItem(item))
  } catch (e) {
    console.log(e)
    return undefined
  }
}
